/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type StatisticsPeriod = 'TODAY' | 'WEEK' | 'MONTH' | 'THREE_MONTHS';

export const StatisticsPeriod = {
    Today: 'TODAY' as StatisticsPeriod,
    Week: 'WEEK' as StatisticsPeriod,
    Month: 'MONTH' as StatisticsPeriod,
    ThreeMonths: 'THREE_MONTHS' as StatisticsPeriod
};

